import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import styled, { css } from 'styled-components';
import { connect } from '../../Store';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: ${rem(10)};
  margin-bottom: ${rem(10)};
  font-size: ${rem(14)};
`;

const Row = styled.div`
  height: ${rem(30)};
  display: flex;
  padding: ${rem(5)} ${rem(10)} ${rem(5)} ${rem(10)};
  border-bottom: ${rem(1)} solid #cbd2d7;
  ${props => {
    if (props.titleLine) {
      return css`
        background: #d7dee4;
      `;
    }
    if (props.highLine) {
      return css`
        background: #3e3c3c;
        color: white;
        font-weight: 400;
        font-size: ${rem(16)};
      `;
    }
    return css``;
  }}
`;

const LeftPart = styled.div`
  width: 50%;
  align-items: center;
  display: flex;
  justify-content: flex-start;
`;

const RightPart = styled.div`
  width: 50%;
  align-items: center;
  display: flex;
  justify-content: flex-end;
`;

class SummaryInfo extends React.Component {
  render() {
    const { data } = this.props;

    return (
      <Wrapper>
        {data.map(row => {
          return (
            <Row titleLine={row.titleLine} highLine={row.highLine}>
              <LeftPart>{row.title}</LeftPart>
              <RightPart>{row.value}</RightPart>
            </Row>
          );
        })}
      </Wrapper>
    );
  }
}

SummaryInfo.propTypes = {
  data: PropTypes.PropTypes.shape({
    title: PropTypes.string,
    hightLine: PropTypes.bool,
    titleLine: PropTypes.bool,
    background: PropTypes.string,
  }).isRequired,
};

SummaryInfo.defaultProps = {};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(SummaryInfo);



// WEBPACK FOOTER //
// ./src/Components/SummaryInfo/index.jsx